const lb = angular.module('app.lb', []);

lb.run([
  '$rootScope',
  '$state',
  'AUTH_EVENTS',
  ($rootScope, $state, AUTH_EVENTS) =>
    $rootScope.$on(AUTH_EVENTS.logoutSuccess, function () {
      $state.go('landing.login');
    }),
]);

export default lb;



// WEBPACK FOOTER //
// ./src/appSpecificImports/index.lb.js